module.exports = __webpack_public_path__ + "img/chart_add.3d550559.svg";